import React from 'react';
import { useStyles, StyledTableCell, StyledTableRow } from './InvoiceStyle';
import SearchIcon from '../../../assets/icons/searchIcon.svg';
import LeftArrow from '../../../assets/icons/leftArrow.svg';
import RightArrow from '../../../assets/icons/rightArrow.svg';
import LightBar from '../../../assets/icons/lightBar.svg';
import DarkBar from '../../../assets/icons/darkBar.svg';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import GreenBulletIcon from '../../../assets/icons/greenBullet.png';
export default function Invoice({ data, headings }) {
    const styles = useStyles();
    const [searchVal, setSearchVal] = React.useState('');
    return (
        <div>
            <p className={styles.invoiceHeading}>Invoices</p>
            <div className={styles.searchAndButtonsRow}>
                <div className={styles.inputWithIconContainer}>
                    <input onChange={(e) => setSearchVal(e.target.value)} className={styles.searchInput} type="text" placeholder='Search by period....' />
                    <div className={styles.iconContainer}>
                        <img src={SearchIcon} alt="icon" />
                    </div>
                </div>
                <div className={styles.btnsRow}>
                    <p className={styles.creditNumber}>1 Credit</p>
                    <div className={styles.allBtnsContainer}>
                        <div className={styles.twoBtnsContainer}>
                            <div className={styles.singleBtnContainer}>
                                <img className={styles.iconImg} src={LeftArrow} alt="icon" />
                            </div>
                            <div className={styles.singleBtnContainer}>
                                <img className={styles.iconImg} src={RightArrow} alt="icon" />
                            </div>
                        </div>
                        <div className={styles.threeBtnsContainer}>
                            <div className={styles.singleBtnContainer}>
                                <img className={styles.iconImg} src={LightBar} alt="icon" />
                            </div>
                            <div className={styles.singleBtnContainer}>
                                <img className={styles.iconImg} src={DarkBar} alt="icon" />
                            </div>
                            <div className={styles.singleBtnContainer}>
                                <img className={styles.iconImg} src={LightBar} alt="icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <TableContainer component={Paper} className={styles.eventContainer} >
                <Table className={styles.table} size="medium" aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            {
                                headings?.map((item) => {
                                    return (
                                        <StyledTableCell >{item}</StyledTableCell>
                                    )
                                })
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            data?.filter((item) => {
                                if (item?.period.toLowerCase().includes(searchVal.toLowerCase())) {
                                    return item;
                                }
                            })?.map((item, index) => (
                                <StyledTableRow >
                                    <StyledTableCell >{item?.period}</StyledTableCell>
                                    <StyledTableCell >{item?.billingGroup}</StyledTableCell>
                                    <StyledTableCell><div className={styles.butlletIconAndStateRow}>{item?.state && <img className={styles.bulletIcon} src={GreenBulletIcon} />}{index % 2 !== 0 ? 'Paid' : item?.state}</div></StyledTableCell>
                                    <StyledTableCell >{item?.amount}</StyledTableCell>
                                    <StyledTableCell >{item?.tax}</StyledTableCell>
                                    <StyledTableCell >{item?.total}</StyledTableCell>
                                    <StyledTableCell ><div className={styles.iconsContainerRow}><img className={styles.eyeIcon} src={item?.eyeIcon} /><img width={2} height={15} src={item?.verticalDivider} /><img className={styles.uploadIcon} src={item?.uploadIcon} /></div></StyledTableCell>
                                </StyledTableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
